module.exports = __webpack_public_path__ + "static/media/DSC_0132.1c3bbf66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0132.jpg
// module id = 633
// module chunks = 0